export default __webpack_public_path__ + "images/assets/c041b2f1dacaffddb7a0eb0b33d00d8b.svg";